// eslint-disable-next-line no-restricted-imports
import { Typography } from '@mui/material';
import { Pressed } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const HintStyled = styled(Pressed)(() => ({
  cursor: 'pointer',

  '.hint-info': {
    color: Colors.blue300,

    ':hover': {
      color: Colors.hover,
    },
  },
}));

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  whiteSpace: 'pre-wrap',
}));
